// Admin module constants

// Module connection status enum
export const moduleConnectionStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  ERROR: 'Error',
  UNKNOWN: 'Unknown'
};

// Core modules that should be available in the admin panel
export const CORE_MODULES = [
  'roadscope',
  'roadguard',
  'permitpro',
  'cargocare',
  'team',
  'settings'
];

// Admin roles and permissions
export const ADMIN_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  VIEWER: 'viewer'
};

// Admin module endpoints
export const MODULE_ENDPOINTS = {
  roadscope: {
    baseUrl: '/roadscope',
    apiEndpoint: '/api/roadscope'
  },
  roadguard: {
    baseUrl: '/roadguard',
    apiEndpoint: '/api/roadguard'
  },
  permitpro: {
    baseUrl: '/permitpro',
    apiEndpoint: '/api/permitpro'
  },
  cargocare: {
    baseUrl: '/cargocare',
    apiEndpoint: '/api/cargocare'
  },
  team: {
    baseUrl: '/team',
    apiEndpoint: '/api/team'
  },
  settings: {
    baseUrl: '/settings',
    apiEndpoint: '/api/settings'
  }
};

// Admin panel sections
export const ADMIN_SECTIONS = {
  DASHBOARD: 'dashboard',
  USERS: 'users',
  MODULES: 'modules',
  SETTINGS: 'settings',
  LOGS: 'logs',
  BACKUP: 'backup',
  MAINTENANCE: 'maintenance'
};